"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorPicker = void 0;
var React = require("react");
var ColorPicker_st_css_1 = require("./ColorPicker.st.css");
var ColorPickerItem_1 = require("./ColorPickerItem");
var dataHooks_1 = require("./dataHooks");
/** ColorPicker */
var ColorPicker = /** @class */ (function (_super) {
    __extends(ColorPicker, _super);
    function ColorPicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColorPicker.prototype.render = function () {
        var _a = this.props, onChange = _a.onChange, children = _a.children, className = _a.className;
        return (React.createElement("div", { className: ColorPicker_st_css_1.st(ColorPicker_st_css_1.classes.root, className), "data-hook": this.props['data-hook'] }, React.Children.map(children, function (item, index) {
            if (!React.isValidElement(item)) {
                return null;
            }
            return React.cloneElement(item, {
                onChange: onChange,
                key: index,
                className: ColorPicker_st_css_1.classes.item,
            });
        })));
    };
    ColorPicker.displayName = dataHooks_1.colorPickerDataHook;
    ColorPicker.Item = function (props) { return React.createElement(ColorPickerItem_1.ColorPickerItem, __assign({}, props)); };
    return ColorPicker;
}(React.Component));
exports.ColorPicker = ColorPicker;
//# sourceMappingURL=ColorPicker.js.map